import { ArrowLeft, CaretRight, User as UserIcon } from "phosphor-react";
import React, { createRef, Fragment, useEffect, useState } from "react"
import { translate } from "../../Services/translation";
import SideMenu from "../SideMenu"
import ProductsContainer from "../../Containers/Products.container"
import ChannelPickerContiner from "../../Containers/ChannelPicker.container";

const MobileNavigation = ({ mobileOpen, closeMobile, blockElements, mobileExtraLinks, contentLinks, myPageUrl, loginPageUrl, startPageUrl, mobileHeaderTitle, mobileHeaderTitleUrl, channelPickerItemList }) => {
    const blockAreaRef = createRef()
    const [currentLink, setCurrentLink] = useState()
    const isLoggedIn = window.__litium.isLoggedIn

    const showChildLinks = (e, link) => {
        e.preventDefault()
        var linkCopy = link
        if (currentLink)
            linkCopy.parent = currentLink
        setCurrentLink(linkCopy)
    }

    const goToParentLink = () => {
        if (currentLink && currentLink.parent)
            setCurrentLink(currentLink.parent)
        else
            setCurrentLink(undefined)
    }

    const headerComponent = currentLink
        ? <div className="side-menu__header-text">
            <span className="side-menu__back-button" onClick={goToParentLink}>
                <ArrowLeft size="20" />
                <span className="side-menu__back-button__label">{currentLink.name}</span>
            </span>
        </div>
        : <>
            {mobileHeaderTitle && <a href={mobileHeaderTitleUrl} className="side-menu__header-cta">{mobileHeaderTitle}</a>}
            {!mobileHeaderTitle && <a href={startPageUrl} className="side-menu__header-logo"><img src={window.__litium.logoUrl} /></a>}
        </>

    const footerComponent = <>
        <a href={isLoggedIn ? myPageUrl : loginPageUrl} className="side-menu__footer-link">
            <i className="icon-login"></i>
            {isLoggedIn && <span dangerouslySetInnerHTML={{__html: window.__litium.currentPersonName}}></span>}
            {!isLoggedIn && translate("header.login-register-link")}
        </a>
        <ChannelPickerContiner itemList={channelPickerItemList} />
    </>

    const hasChildren = link => link.links && link.links.length > 0

    const links = currentLink ? currentLink.links : contentLinks

    
    const blocks = blockElements && currentLink && currentLink.blocks ? blockElements.filter(b => currentLink.blocks.indexOf(b.dataset["litiumBlockId"]) != -1) : null;
    const hasBlocks = blocks && blocks.length > 0;

    /**
     * Append blocks to the block area div
     */
    useEffect(() => {
        if(!blockAreaRef || !blockAreaRef.current || !hasBlocks) return;
        for(let block of blocks) {
            blockAreaRef.current.appendChild(block);
        }
    }, [blockAreaRef])

    return <SideMenu id="MobileNavigation" header={headerComponent} footer={footerComponent} open={mobileOpen} onClosed={closeMobile} from="left" duration="0.25s">
        {(!currentLink || !currentLink.isCustomMegaMenu) && links.map(link =>
            <li key={link.name + link.url} className="side-menu__link">
                <a href={link.url}
                    onClick={e => hasChildren(link) ? showChildLinks(e, link) : link.url}
                    style={{
                        flexGrow: !hasChildren(link) ? 1 : null,
                        color: link.nameColor,
                        fontWeight: link.nameBold ? 600 : null
                    }}>
                    {link.name}
                    {link.tagValue && <span className={"link-tag link-tag--" + link.tagValue}>{link.tagName}</span>}
                </a>
                {hasChildren(link) && <div className="side-menu__child-link" onClick={e => hasChildren(link) && showChildLinks(e, link)}>
                    <CaretRight size="14" color="#757575" />
                </div>}
            </li>
        )}
        {currentLink && currentLink.isCustomMegaMenu && currentLink.links.map((section, idx) => <Fragment key={section.name + section.url + idx}>
            <div className="side-menu__section-header" style={{ color: section.nameColor, fontWeight: section.nameBold ? 600 : null }}>{section.name}</div>
            <ul>
                {section.links.map((link, idx) => <Fragment key={link.name + link.url + idx}>
                    <li className="side-menu__link">
                        <a href={link.url} style={{ flexGrow: 1, fontWeight: link.nameBold ? 600 : null }}>
                            {link.name}
                            {link.tagValue && <span className={"link-tag link-tag--" + link.tagValue}>{link.tagName}</span>}
                        </a>
                    </li>
                </Fragment>)}
            </ul>
        </Fragment>)}
        {/* {currentLink && currentLink.imageLinkBlocks && currentLink.imageLinkBlocks.length > 0 &&
            <div className="mega-menu__image-link-blocks">
                {currentLink.imageLinkBlockSectionTitle && <div className="side-menu__section-header">{currentLink.imageLinkBlockSectionTitle}</div>}
                <div className="row expanded">
                    {currentLink.imageLinkBlocks.map((block, idx) => <a href={block.url} key={"mobile-menu-block" + idx} className={"mega-menu__image-link-block columns small-" + Math.floor(12 / currentLink.imageLinkBlocks.length)}>
                        <img src={block.mobileImageUrl || block.imageUrl} />
                        <div className="mega-menu__image-link-block-text" style={{ color: block.textColor }}>
                            <div className="kicker-small">{block.preTitle}</div>
                            <div className="rich-text-wrapper" dangerouslySetInnerHTML={{ __html: block.text }}></div>
                        </div>
                    </a>)}
                </div>
            </div>
        }
        {currentLink && currentLink.products && currentLink.products.length > 0 &&
            <div className="mega-menu__products">
                {currentLink.productsSectionTitle && <div className="side-menu__section-header">{currentLink.productsSectionTitle}</div>}
                <ProductsContainer show={productShowList} products={currentLink.products} />
            </div>
        } */}
        {!currentLink && mobileExtraLinks.length > 0 && <>
            <div className='side-menu__divider'></div>
            {mobileExtraLinks.map((link, idx) => <Fragment key={`${link.name}${link.url}${idx}`}>
                <li className="side-menu__link">
                    <a href={link.url} style={{ flexGrow: 1 }}>
                        {link.name}
                    </a>
                </li>
            </Fragment>)}
        </>}
        {hasBlocks && <div>
            {currentLink.blockSectionTitle && <div className='side-menu__section-header'>{currentLink.blockSectionTitle}</div>}
            <div ref={blockAreaRef}></div>
        </div>}
    </SideMenu>
}

export default MobileNavigation